import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, tap } from 'rxjs/operators';

import { OrderFillService } from '@ruby/core/http/order-fill/order-fill.service';
import { IOrderFill } from '@ruby/modules/order-fill/model/order-fill.interface';
import * as OrderFillActions from '@ruby/modules/order-fill/store/actions/order-fill.actions';
import { IError } from '@ruby/shared/models/request/error.interface';
import { UtilsService } from '@ruby/shared/services/utils/utils.service';

@Injectable()
export class OrderFillEffects {

  loadSummary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrderFillActions.loadSummary),
      exhaustMap((action) => this.orderFillService.getSummary(action.data).pipe(
        map((data: IOrderFill) => OrderFillActions.loadSummarySuccess({ data })),
        catchError((error: IError) => of(OrderFillActions.loadSummaryFailure({ error })))
      ))
    ));

  failure$ = createEffect(() =>
      this.actions$.pipe(
        ofType(
          OrderFillActions.loadSummaryFailure
        ),
        tap(action => this.utilsService.showErrorToastr(action.error.title, action.error.message))
      ),
    { dispatch: false }
  );

  constructor(private actions$: Actions, private orderFillService: OrderFillService, private utilsService: UtilsService) {}
}
